import { render, staticRenderFns } from "./CurrencySelect.vue?vue&type=template&id=0883d4f2&"
import script from "./CurrencySelect.vue?vue&type=script&lang=ts&"
export * from "./CurrencySelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0883d4f2')) {
      api.createRecord('0883d4f2', component.options)
    } else {
      api.reload('0883d4f2', component.options)
    }
    module.hot.accept("./CurrencySelect.vue?vue&type=template&id=0883d4f2&", function () {
      api.rerender('0883d4f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/CurrencySelect.vue"
export default component.exports